import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/sessions/invisible-square.png'


const _hoisted_1 = { class: "absolute-visual-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "absolute-sizer",
  src: _imports_0,
  alt: "transparent square"
}, null, -1)

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'absolute-visual',
  props: {
    fullSize: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const fullSize = computed(() => props?.fullSize ?? false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["visual absolute-visuals", { 'side-visual': !fullSize.value, 'full-size-visual': fullSize.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})